export default "__VITE_ASSET__571d53b4__"